'use strict';

var _toConsumableArray = require("/tmp/323738e2/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/tmp/323738e2/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var calculateTotalDuration = function calculateTotalDuration(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.3 : _ref$duration,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? 0 : _ref$overlay;
  return duration + delay - overlay || 0;
};

function getSequenceId(sequenceIndex, sequenceId, defaultValue) {
  if (sequenceId === undefined && sequenceIndex === undefined) return defaultValue || 0;
  if (sequenceIndex && sequenceIndex >= 0) return sequenceIndex;
  if (sequenceId) return sequenceId;
  return 0;
}

var useState = React.useState,
    useRef = React.useRef,
    useEffect = React.useEffect;
var AnimateContext = React.createContext({
  animationStates: {},
  register: function register(data) {}
});

function AnimateGroup(props) {
  var play = props.play,
      _props$sequences = props.sequences,
      sequences = _props$sequences === void 0 ? [] : _props$sequences,
      children = props.children;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      animationStates = _useState2[0],
      setAnimationStates = _useState2[1];

  var animationsRef = useRef({});

  var register = function register(data) {
    var sequenceIndex = data.sequenceIndex,
        sequenceId = data.sequenceId;
    if (sequenceId === undefined && sequenceIndex === undefined) return;
    animationsRef.current[getSequenceId(sequenceIndex, sequenceId)] = data;
  };

  useEffect(function () {
    var sequencesToAnimate = Array.isArray(sequences) && sequences.length ? sequences : Object.values(animationsRef.current);
    var localAnimationState = {};
    (play ? sequencesToAnimate : _toConsumableArray(sequencesToAnimate).reverse()).reduce(function (previous, current, currentIndex) {
      var sequenceId = current.sequenceId,
          sequenceIndex = current.sequenceIndex,
          restAttributes = __rest(current, ["sequenceId", "sequenceIndex"]);

      var duration = restAttributes.duration,
          delay = restAttributes.delay,
          overlay = restAttributes.overlay;
      var id = getSequenceId(sequenceIndex, sequenceId, currentIndex);
      var totalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      }) + previous;
      localAnimationState[id] = {
        play: play,
        delay: currentIndex === 0 ? delay || 0 : previous
      };
      return totalDuration;
    }, 0);
    setAnimationStates(localAnimationState);
  }, [play]); // @ts-ignore

  return React.createElement(AnimateContext.Provider, {
    value: {
      animationStates: animationStates,
      register: register
    }
  }, children);
}

var msToSec = function msToSec(ms) {
  return (ms || 0) * 1000;
};

var useEffect$1 = React.useEffect,
    useState$1 = React.useState,
    useRef$1 = React.useRef,
    useContext = React.useContext;

function Animate(props) {
  var play = props.play,
      children = props.children,
      render = props.render,
      start = props.start,
      end = props.end,
      _props$complete = props.complete,
      complete = _props$complete === void 0 ? '' : _props$complete,
      onComplete = props.onComplete,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 0.3 : _props$duration,
      _props$easeType = props.easeType,
      easeType = _props$easeType === void 0 ? 'linear' : _props$easeType,
      sequenceId = props.sequenceId,
      sequenceIndex = props.sequenceIndex;
  var onCompleteTimeRef = useRef$1(null);

  var _useState$ = useState$1(start || {}),
      _useState$2 = _slicedToArray(_useState$, 2),
      style = _useState$2[0],
      setStyle = _useState$2[1];

  var _useContext = useContext(AnimateContext),
      register = _useContext.register,
      _useContext$animation = _useContext.animationStates,
      animationStates = _useContext$animation === void 0 ? {} : _useContext$animation;

  var id = getSequenceId(sequenceIndex, sequenceId);
  useEffect$1(function () {
    if (sequenceIndex !== undefined && sequenceIndex >= 0 || sequenceId) register(props);
  }, []);
  useEffect$1(function () {
    setStyle(Object.assign({}, play || (animationStates[id] || {}).play ? end : start, {
      transition: "all ".concat(duration, "s ").concat(easeType, " ").concat(parseFloat((animationStates[id] || {}).delay || delay), "s")
    }));

    if (play && (complete || onComplete)) {
      // @ts-ignore
      onCompleteTimeRef.current = setTimeout(function () {
        complete && setStyle(complete);
        onComplete && onComplete();
      }, msToSec(parseFloat((animationStates[id] || {}).delay || delay) + duration));
    }

    return function () {
      // @ts-ignore
      onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, [id, animationStates, play, duration, easeType, delay, onComplete, start, end, complete]);
  return render ? render({
    style: style
  }) : React.createElement("div", {
    style: style
  }, children);
}

function createStyle(_ref2) {
  var keyframes = _ref2.keyframes,
      animationName = _ref2.animationName;
  var animationLength = keyframes.length;
  return "".concat(keyframes.reduce(function (previous, keyframe, currentIndex) {
    if (keyframe) {
      return "".concat(previous, " ").concat(animationLength === 2 ? currentIndex * 100 : parseFloat((100 / (animationLength - 1)).toFixed(2)) * currentIndex, "% {").concat(keyframe, "}");
    }

    return "".concat(previous, " ").concat(Object.keys(keyframe)[0], "% {").concat(Object.values(keyframe)[0], "}");
  }, "@keyframes ".concat(animationName, " {")), "}");
}

function createTag(_ref3) {
  var keyframes = _ref3.keyframes,
      animationName = _ref3.animationName;
  var styleTag = document.querySelector('style[data-id=rsi]');
  var index = 0;

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.setAttribute('data-id', 'rsi');
    document.head.appendChild(styleTag);
  }

  try {
    // @ts-ignore
    index = styleTag.sheet.cssRules.length;
  } catch (e) {
    index = 0;
  }

  try {
    // @ts-ignore
    styleTag.sheet.insertRule(createStyle({
      keyframes: keyframes,
      animationName: animationName
    }), index);
  } catch (e) {
    console.error('react simple animate, error found during insert style ', e); // eslint-disable-line no-console
  }

  return {
    styleTag: styleTag,
    index: index
  };
}

var createRandomName = function createRandomName() {
  return "RSI-".concat(Math.random().toString(36).substr(2, 9));
};

var deleteRules = function deleteRules(sheet, deleteName) {
  var index = Object.values(sheet.cssRules).findIndex(function (_ref4) {
    var name = _ref4.name;
    return name === deleteName;
  });
  if (index >= 0) sheet.deleteRule(index);
};

var useRef$2 = React.useRef,
    useEffect$2 = React.useEffect,
    useContext$1 = React.useContext,
    useState$2 = React.useState;

function AnimateKeyframes(props) {
  var children = props.children,
      play = props.play,
      render = props.render,
      _props$duration2 = props.duration,
      duration = _props$duration2 === void 0 ? 0.3 : _props$duration2,
      _props$delay2 = props.delay,
      delay = _props$delay2 === void 0 ? 0 : _props$delay2,
      _props$easeType2 = props.easeType,
      easeType = _props$easeType2 === void 0 ? 'linear' : _props$easeType2,
      _props$playState = props.playState,
      playState = _props$playState === void 0 ? 'running' : _props$playState,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'normal' : _props$direction,
      _props$fillMode = props.fillMode,
      fillMode = _props$fillMode === void 0 ? 'none' : _props$fillMode,
      _props$iterationCount = props.iterationCount,
      iterationCount = _props$iterationCount === void 0 ? 1 : _props$iterationCount,
      keyframes = props.keyframes;
  var animationNameRef = useRef$2('');
  var styleTagRef = useRef$2({
    sheet: {}
  });

  var _useContext$ = useContext$1(AnimateContext),
      register = _useContext$.register;

  var forceUpdate = useState$2(false)[1];
  useEffect$2(function () {
    animationNameRef.current = createRandomName();

    var _createTag = createTag({
      animationName: animationNameRef.current,
      keyframes: keyframes
    }),
        styleTag = _createTag.styleTag;

    styleTagRef.current = styleTag;
    register(props);
    if (play) forceUpdate(true);
    return function () {
      return deleteRules(styleTagRef.current.sheet, animationNameRef.current);
    };
  }, []);
  var style = play ? {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(playState, " ").concat(animationNameRef.current || '')
  } : null;
  return render ? render({
    style: style
  }) : React.createElement("div", {
    style: style || {}
  }, children);
}

function useAnimate(props) {
  var start = props.start,
      end = props.end,
      complete = props.complete,
      onComplete = props.onComplete,
      _props$delay3 = props.delay,
      delay = _props$delay3 === void 0 ? 0 : _props$delay3,
      _props$duration3 = props.duration,
      duration = _props$duration3 === void 0 ? 0.3 : _props$duration3,
      _props$easeType3 = props.easeType,
      easeType = _props$easeType3 === void 0 ? 'linear' : _props$easeType3;
  var transition = "all ".concat(duration, "s ").concat(easeType, " ").concat(delay, "s");

  var _React$useState = React.useState(Object.assign({}, start, {
    transition: transition
  })),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      style = _React$useState2[0],
      setStyle = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isPlaying = _React$useState4[0],
      setIsPlaying = _React$useState4[1];

  var onCompleteTimeRef = React.useRef(0);
  React.useEffect(function () {
    return function () {
      onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, []);

  var play = function play(isPlay) {
    setStyle(Object.assign({}, isPlay ? end : start, {
      transition: transition
    }));
    setIsPlaying(isPlay);

    if (isPlay && (complete || onComplete)) {
      // @ts-ignore
      onCompleteTimeRef.current = setTimeout(function () {
        // @ts-ignore
        complete && setStyle(complete);
        onComplete && onComplete();
      }, msToSec(delay + duration));
    }
  };

  return {
    isPlaying: isPlaying,
    style: style,
    play: play
  };
}

function useAnimateKeyframes(props) {
  var _props$duration4 = props.duration,
      duration = _props$duration4 === void 0 ? 0.3 : _props$duration4,
      _props$delay4 = props.delay,
      delay = _props$delay4 === void 0 ? 0 : _props$delay4,
      _props$easeType4 = props.easeType,
      easeType = _props$easeType4 === void 0 ? 'linear' : _props$easeType4,
      _props$direction2 = props.direction,
      direction = _props$direction2 === void 0 ? 'normal' : _props$direction2,
      _props$fillMode2 = props.fillMode,
      fillMode = _props$fillMode2 === void 0 ? 'none' : _props$fillMode2,
      _props$iterationCount2 = props.iterationCount,
      iterationCount = _props$iterationCount2 === void 0 ? 1 : _props$iterationCount2,
      _props$playState2 = props.playState,
      playState = _props$playState2 === void 0 ? 'running' : _props$playState2,
      keyframes = props.keyframes;
  var animationNameRef = React.useRef('');
  var styleTagRef = React.useRef('');

  var _React$useContext = React.useContext(AnimateContext),
      register = _React$useContext.register;

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isPlaying = _React$useState6[0],
      setIsPlaying = _React$useState6[1];

  React.useEffect(function () {
    animationNameRef.current = createRandomName();

    var _createTag2 = createTag({
      animationName: animationNameRef.current,
      keyframes: keyframes
    }),
        styleTag = _createTag2.styleTag;

    styleTagRef.current = styleTag;
    register(props); // @ts-ignore

    return function () {
      return deleteRules(styleTagRef.current.sheet, animationNameRef.current);
    };
  }, []);

  var play = function play(isPlay) {
    setIsPlaying(isPlay);
  };

  var style = isPlaying ? {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(playState, " ").concat(animationNameRef.current || '')
  } : null;
  return {
    style: style,
    play: play,
    isPlaying: isPlaying
  };
}

function createArrayWithNumbers(length) {
  return Array.from({
    length: length
  }, function () {
    return null;
  });
}

function useAnimateGroup(props) {
  var _props$sequences2 = props.sequences,
      sequences = _props$sequences2 === void 0 ? [] : _props$sequences2;
  var defaultArray = createArrayWithNumbers(sequences.length);

  var _React$useState7 = React.useState(defaultArray),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      styles = _React$useState8[0],
      setStyles = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      isPlaying = _React$useState10[0],
      setPlaying = _React$useState10[1];

  var animationNamesRef = React.useRef({});
  React.useEffect(function () {
    var localStyleTag; // @ts-ignore

    sequences.forEach(function (_ref5, i) {
      var _ref5$keyframes = _ref5.keyframes,
          keyframes = _ref5$keyframes === void 0 ? false : _ref5$keyframes;
      if (!Array.isArray(keyframes)) return;
      var animationName = createRandomName();
      animationNamesRef.current[i] = animationName;

      var _createTag3 = createTag({
        animationName: animationName,
        keyframes: keyframes
      }),
          styleTag = _createTag3.styleTag;

      localStyleTag = styleTag;
    });
    return function () {
      if (!localStyleTag) return;
      Object.values(animationNamesRef).forEach(function (name) {
        deleteRules(localStyleTag.sheet, name);
      });
    };
  }, []);

  var play = function play(isPlay) {
    var totalDuration = 0;
    var styles = (isPlay ? sequences : _toConsumableArray(sequences).reverse()).map(function (current, currentIndex) {
      var _current$duration = current.duration,
          duration = _current$duration === void 0 ? 0.3 : _current$duration,
          _current$delay = current.delay,
          delay = _current$delay === void 0 ? 0 : _current$delay,
          overlay = current.overlay,
          keyframes = current.keyframes,
          _current$iterationCou = current.iterationCount,
          iterationCount = _current$iterationCou === void 0 ? 1 : _current$iterationCou,
          _current$easeType = current.easeType,
          easeType = _current$easeType === void 0 ? 'linear' : _current$easeType,
          _current$playState = current.playState,
          playState = _current$playState === void 0 ? 'running' : _current$playState,
          _current$direction = current.direction,
          direction = _current$direction === void 0 ? 'normal' : _current$direction,
          _current$fillMode = current.fillMode,
          fillMode = _current$fillMode === void 0 ? 'none' : _current$fillMode,
          _current$end = current.end,
          end = _current$end === void 0 ? {} : _current$end,
          _current$start = current.start,
          start = _current$start === void 0 ? {} : _current$start;
      var delayDuration = currentIndex === 0 ? delay : totalDuration;
      totalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      }) + totalDuration;

      if (keyframes) {
        return isPlay ? {
          animation: "".concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(playState, " ").concat(animationNamesRef.current[currentIndex])
        } : {};
      }

      var transition = "all ".concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s");
      return Object.assign({}, isPlay ? end : start, {
        transition: transition
      });
    }); // @ts-ignore

    setStyles(isPlay ? styles : _toConsumableArray(styles).reverse());
    setPlaying(!isPlaying);
  };

  return {
    styles: styles,
    play: play,
    isPlaying: isPlaying
  };
}

exports.Animate = Animate;
exports.AnimateGroup = AnimateGroup;
exports.AnimateKeyframes = AnimateKeyframes;
exports.useAnimate = useAnimate;
exports.useAnimateGroup = useAnimateGroup;
exports.useAnimateKeyframes = useAnimateKeyframes;